<template>
  <div class="content">
    <div>
      <!-- 订单号检索 -->
      <div class="select">
        <a-input v-model:value="selectedOrderNumber"
                 :placeholder="`${$t('financial.FinancialFundDetails.enter')}${selectInputValue}${$t('financial.FinancialFundDetails.retrieval')}`"
                 class="select-input"
                 @press-enter="changeSelectCondition">
          <template #addonBefore>
            <a-select v-model:value="selectInputValue">
              <a-select-option :value="$t('financial.FinancialFundDetails.orderNumber')">{{
                $t('financial.FinancialFundDetails.orderNumber') }}</a-select-option>
              <a-select-option :value="$t('financial.FinancialFundDetails.tradeNumber')">{{
                $t('financial.FinancialFundDetails.tradeNumber') }}</a-select-option>
            </a-select>
          </template>
        </a-input>
        <div style="display: flex;">
          <a-button class="select-button"
                    @click="changeSelectCondition">
            <template #icon>
              <SearchOutlined />
            </template>{{ $t('financial.FinancialFundDetails.search') }}
          </a-button>
          <a-button class="select-button select-button-white"
                    @click="resetSelect">
            <template #icon>
              <redo-outlined />
            </template>
            {{ $t('financial.FinancialFundDetails.reset') }}
          </a-button>
        </div>
      </div>
      <!-- 分割线 -->
      <div class="line"></div>
      <!-- 条件筛选 -->
      <div class="filter">
        <div>
          <span>{{ $t('financial.FinancialFundDetails.orderTime') }} </span>
          <a-space direction="vertical"
                   class="filter-select-time">
            <a-range-picker v-model:value="selectTimeValue"
                            value-format="YYYY/MM/DD"
                            @change="changeSelectCondition" />
          </a-space>
        </div>
        <div>
          <span>{{ $t('financial.FinancialFundDetails.moneyFlow') }} </span>
          <a-select ref="select"
                    v-model:value="selectMoneyFlow"
                    :placeholder="$t('financial.FinancialFundDetails.select')"
                    class="filter-select"
                    @change="changeSelectCondition">
            <a-select-option value="0">{{ $t('financial.FinancialFundDetails.income') }}</a-select-option>
            <a-select-option value="1">{{ $t('financial.FinancialFundDetails.expenditure') }}</a-select-option>
          </a-select>
        </div>
        <div>
          <span>{{ $t('financial.FinancialFundDetails.orderType') }} </span>
          <a-select ref="select"
                    v-model:value="selectTradeType"
                    :placeholder="$t('financial.FinancialFundDetails.select')"
                    class="filter-select"
                    @change="changeSelectCondition">
            <a-select-option value="0">{{ $t('financial.FinancialFundDetails.order') }}</a-select-option>
            <a-select-option value="1">{{ $t('financial.FinancialFundDetails.chargeback') }}</a-select-option>
          </a-select>
        </div>
        <div>
          <span>{{ $t('financial.FinancialFundDetails.payType') }} </span>
          <a-select ref="select"
                    v-model:value="selectPayType"
                    :placeholder="$t('financial.FinancialFundDetails.select')"
                    class="filter-select"
                    @change="changeSelectCondition">
            <a-select-option value="0">{{ $t('financial.FinancialFundDetails.alipay') }}</a-select-option>
            <a-select-option value="1">{{ $t('financial.FinancialFundDetails.wxpay') }}</a-select-option>
            <a-select-option value="2">{{ $t('financial.FinancialFundDetails.wxpay') }}-{{
              $t('financial.FinancialFundDetails.app') }}</a-select-option>
          </a-select>
        </div>
      </div>
    </div>
    <a-scroll-table class="table"
                    :columns="FUND_DETAILS_COLUMNS"
                    :data-source="dataSource"
                    :pagination="false"
                    row-key="id">
      <template #bodyCell="{ column, record }">
        <template v-if="column.dataIndex === 'time'">
          <span>
            {{ dayjs(record.createdAt).format('YYYY-MM-DD') }}
          </span>
        </template>
        <template v-if="column.dataIndex === 'accounting_period'">
          <span>
            {{ dayjs(record.createdAt).format('YYYY-MM-DD HH:mm:ss') }}
          </span>
        </template>
        <template v-if="column.dataIndex === 'money_flow'">
          <span v-if="record.money_flow"
                class="color-volcano">
            {{ $t('financial.FinancialFundDetails.expenditure') }}
          </span>
          <span v-else
                class="color-green">
            {{ $t('financial.FinancialFundDetails.income') }}
          </span>
        </template>
        <template v-if="column.dataIndex === 'trade_type'">
          <span v-if="record.trade_type">
            {{ $t('financial.FinancialFundDetails.refund') }}
          </span>
          <span v-else>
            {{ $t('financial.FinancialFundDetails.consumption') }}
          </span>
        </template>
        <template v-if="column.dataIndex === 'order_type'">
          <span v-if="record.order_type == 0">
            {{ $t('financial.FinancialFundDetails.chargeback') }}
          </span>
          <span v-else>
            {{ $t('financial.FinancialFundDetails.order') }}
          </span>
        </template>
        <template v-if="column.dataIndex === 'pay_type'">
          <span v-if="record.pay_type == 0">
            {{ $t('financial.FinancialFundDetails.alipay') }}
          </span>
          <span v-else-if="record.pay_type == 1">
            {{ $t('financial.FinancialFundDetails.wxpay') }}
          </span>
          <span v-else-if="record.pay_type == 2">
            {{ $t('financial.FinancialFundDetails.wxpay') }}-{{ $t('financial.FinancialFundDetails.app') }}
          </span>
          <span v-else>
            {{ $t('financial.FinancialFundDetails.wallet') }}
          </span>
        </template>
        <template v-if="column.dataIndex === 'status'">
          <span v-if="record.status == 1">
            {{ $t('financial.FinancialFundDetails.unfrozen') }}
          </span>
          <span v-else-if="record.status == 2">
            {{ $t('financial.FinancialFundDetails.frozen') }}
          </span>
          <span v-else>
            {{ $t('financial.FinancialFundDetails.refund') }}
          </span>
        </template>
        <template v-if="column.dataIndex === 'type'">
          <span v-if="record.type == 1">
            {{ $t('financial.FinancialFundDetails.order') }}
          </span>
          <span v-else-if="record.type == 2">
            {{ $t('financial.FinancialFundDetails.designRevenue') }}
          </span>
          <span v-else>
            {{ $t('financial.FinancialFundDetails.recharge') }}/{{ $t('financial.FinancialFundDetails.withdrawal') }}
          </span>
        </template>
        <template v-if="column.dataIndex === 'amount'">
          <span :class="record.money_flow ? 'color-volcano' : 'color-green'">
            {{ (record.money_flow ? '-' : '+') + record.amount }}
          </span>
        </template>
      </template>
    </a-scroll-table>
    <div class="footer">
      <APagination v-model:current="pagination.current"
                   v-model:pageSize="pagination.pageSize"
                   :show-size-changer="true"
                   :total="pagination.total"
                   @change="handleTableChange" />
    </div>
  </div>
</template>

<script setup lang="ts">
/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject, ref, onMounted, computed } from 'vue'
import dayjs from 'dayjs'
import { AScrollTable, APagination } from '@iota-cn/ui-components'
import {
  AXIOSKEY
} from '@/core'
import type { TableColumnsType } from 'ant-design-vue'
import { useI18n } from "vue-i18n"

const { t } = useI18n()
interface DataSource {
  id: number,
  money_flow: number,
  trade_type: number,
  order_type: number,
  pay_type: number,
  amount: number,
  out_trade_number: number,
  time: number,
  accounting_period: number,
}

const selectInputValue = ref<string>(t('financial.FinancialFundDetails.orderNumber'))
console.log(t('financial.FinancialFundDetails.number'))
const FUND_DETAILS_COLUMNS = computed<TableColumnsType>(() => [
  {
    title: t('financial.FinancialFundDetails.number'),
    dataIndex: 'number',
    ellipsis: true,
    align: 'center'
  },
  {
    title: t('financial.FinancialFundDetails.time'),
    dataIndex: 'time',
    ellipsis: true,
    align: 'center'
  },
  {
    title: t('financial.FinancialFundDetails.moneyFlow'),
    dataIndex: 'money_flow',
    ellipsis: true,
    align: 'center'
  },
  {
    title: t('financial.FinancialFundDetails.tradeType'),
    dataIndex: 'trade_type',
    ellipsis: true,
    align: 'center'
  },
  {
    title: t('financial.FinancialFundDetails.orderType'),
    dataIndex: 'order_type',
    ellipsis: true,
    align: 'center'
  },
  {
    title: t('financial.FinancialFundDetails.payType'),
    dataIndex: 'pay_type',
    ellipsis: true,
    align: 'center'
  },
  {
    title: t('financial.FinancialFundDetails.status'),
    dataIndex: 'status',
    ellipsis: true,
    align: 'center'
  },
  {
    title: t('financial.FinancialFundDetails.type'),
    dataIndex: 'type',
    ellipsis: true,
    align: 'center'
  },
  {
    title: t('financial.FinancialFundDetails.accountingPeriod'),
    dataIndex: 'accounting_period',
    ellipsis: true,
    align: 'center'
  },
  {
    title: t('financial.FinancialFundDetails.amount'),
    dataIndex: 'amount',
    ellipsis: true,
    align: 'center'
  },
  {
    title: t('financial.FinancialFundDetails.outTradeNumber'),
    dataIndex: 'out_trade_number',
    width: 150,
    ellipsis: true,
    align: 'center'
  },
])
const selectedOrderNumber = ref<string>('')
const selectTimeValue = ref()
const selectMoneyFlow = ref()
const selectTradeType = ref()
const selectPayType = ref()
const dataSource = ref<DataSource[]>([])
const axios = inject(AXIOSKEY)
const pagination = ref({
  current: 1,
  total: 0,
  offset: 0,
  pageSize: 20,
  showSizeChanger: true,
  pageSizeOptions: ['20', '40', '60', '80'], // 每页中显示的数据
  showTotal: (total: number) => `${t('financial.FinancialFundDetails.total')} ${total} ${t('financial.FinancialFundDetails.strip')}`, // 分页中显示总的数据
  size: 'small',
})

onMounted(() => {
  getBmsBillItem()
})

const changeSelectCondition = async () => {
  const condition: any = {}
  if (selectedOrderNumber.value) condition.selectNumber = selectedOrderNumber.value
  if (selectTimeValue.value) {
    condition.selectTime = [selectTimeValue.value[0], selectTimeValue.value[1]]
    condition.selectTime[0] += ' 00:00:00.000 +00:00'
    condition.selectTime[1] += ' 23:59:59.999 +00:00'
  }
  if (selectMoneyFlow.value) condition.money_flow = selectMoneyFlow.value
  if (selectTradeType.value) condition.trade_type = selectTradeType.value
  if (selectPayType.value) condition.pay_type = selectPayType.value
  condition.offset = pagination.value.offset
  condition.limit = pagination.value.pageSize
  await axios?.post('v1/api/bms/bill_item', condition).then((res: any) => {
    dataSource.value = []
    convert(res)
    dataSource.value = res.billItem
  })
}

const resetSelect = () => {
  getBmsBillItem()
  selectedOrderNumber.value = ''
  selectTimeValue.value = undefined
  selectMoneyFlow.value = undefined
  selectTradeType.value = undefined
  selectPayType.value = undefined
}

const convert = (res: any) => {
  pagination.value.total = res.total
  res.billItem.forEach((r: any) => {
    // r.time = dayjs(r.createdAt).format('YYYY-MM-DD')
    // r.accounting_period = dayjs(r.createdAt).format('YYYY-MM-DD HH:mm:ss')
    // r.money_flow = r.money_flow ? t('financial.FinancialFundDetails.expenditure') : t('financial.FinancialFundDetails.income')
    // r.trade_type = r.trade_type ? t('financial.FinancialFundDetails.refund') : t('financial.FinancialFundDetails.consumption')
    // r.order_type = r.order_type ? t('financial.FinancialFundDetails.chargeback') : t('financial.FinancialFundDetails.order')
    // r.pay_type = r.pay_type === 0 ? t('financial.FinancialFundDetails.alipay') : r.pay_type === 1 ? t('financial.FinancialFundDetails.wxpay') : r.pay_type === 2 ? `${t('financial.FinancialFundDetails.wxpay')}-${t('financial.FinancialFundDetails.app')}` : t('financial.FinancialFundDetails.wallet')
    // r.status = r.status === 1 ? t('financial.FinancialFundDetails.unfrozen') : r.status === 2 ? t('financial.FinancialFundDetails.frozen') : t('financial.FinancialFundDetails.refund')
    // r.type = r.type === 1 ? t('financial.FinancialFundDetails.order') : r.type === 2 ? t('financial.FinancialFundDetails.designRevenue') : `${t('financial.FinancialFundDetails.recharge')}/${t('financial.FinancialFundDetails.withdrawal')}`
  })
}

const getBmsBillItem = async () => {
  const temp = {
    temps: {
      limit: pagination.value.pageSize,
      offset: pagination.value.offset
    }
  }
  const res: any = await axios?.get('v1/api/bms/bill_item', temp.temps)
  // convert(res)
  dataSource.value = res.billItem
}

const handleTableChange = (current: number, pageSize: number) => {
  pagination.value.current = current
  pagination.value.offset = (current - 1) * pageSize
  changeSelectCondition()
}

</script>
<style lang="less" scoped>
.content {
  width: 100%;
  height: 100%;
  padding: 24px;
  display: flex;
  flex-direction: column;
  position: relative;

  .color-green {
    color: #23C432FF;
  }

  .color-volcano {
    color: #DE4A09FF;
  }

  .select {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .select-input {
      width: 300px;
      height: 40px;
    }

    .select-button {
      margin-left: 30px;
      width: 68px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .select-button-white {
      width: 98px;
      height: 40px;

    }
  }

  .line {
    border: 1px dashed #F5F5F5;
    margin: 24px 0;
  }

  .filter {
    width: 65vw;
    display: flex;
    align-items: center;
    justify-content: space-between;

    span {
      margin-right: 5px;
    }

    .filter-select-time {
      width: 250px;
    }

    .filter-select {
      width: 150px;
    }
  }

  .table {
    flex: 1;
    margin-top: 20px;
    overflow: hidden;

    :deep(.ant-table-body) {
      max-height: 850px !important;
    }
  }

  .footer {
    display: flex;
    justify-content: end;

    .dropdown-button {
      width: 68px;
    }

    span {
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      margin: auto 10px;
    }

    .pagination-input-search {
      width: 98px;
      margin-left: 10px;

      .pagination-input-search-button {
        background-color: black;
        color: white !important;
        width: 38px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>
